import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export function CrossSellCardSkeleton() {
  return (
    <div className="w-full mt-8">
      <div className="mb-2 w-40">
        <Skeleton height={20} />
      </div>
      <div className="w-full flex gap-3 border border-[#DBDBDB] rounded-2xl py-[18px] px-[30px]">
        <div className="min-w-[66px] w-[66px]">
          <Skeleton height={66} width={66} />
        </div>
        <div className="w-full flex items-center gap-4 justify-between grow">
          <div className="flex flex-col gap-3 w-full">
            <div className="w-full">
              <Skeleton height={14} />
              <Skeleton height={14} width="70%" />
            </div>
            <Skeleton height={20} width={80} />
          </div>
          <div className="min-w-[24px]">
            <Skeleton height={24} width={24} />
          </div>
        </div>
      </div>
    </div>
  )
}
